/* TROVI Marketplace · movimiento (r80 · r86).
   Sin dependencias. Cuatro tareas:
   1) Marca <html class="tv-motion"> para que el CSS pueda esconder el estado
      inicial de los reveals (si este archivo no carga, no se esconde nada).
   2) Revela [data-tv-reveal] al entrar en pantalla.
   3) Da un `view-transition-name` único por producto (imagen de tarjeta y de
      ficha) para que la imagen «vuele» de la lista a la ficha, con
      `view-transition-class: tv-product` para que el CSS controle su duración.
   4) Hace «pop» la burbuja del carrito cuando cambia la cantidad.
   r86: si prefers-reduced-motion cambia durante la visita, se revela todo lo
   pendiente y se retiran los nombres de transición; al volver, se reasignan. */

(function () {
  'use strict';

  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* 1) Reveal al hacer scroll ---------------------------------------------- */
  function revealAll(nodes) {
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-in');
  }

  var revealObserver = null;

  function initReveal(scope) {
    var nodes = (scope || document).querySelectorAll('[data-tv-reveal]');
    if (!nodes.length) return;

    if (reduced.matches || !('IntersectionObserver' in window)) {
      revealAll(nodes);
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries, observer) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            entries[i].target.classList.add('is-in');
            observer.unobserve(entries[i].target);
          }
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
      );
    }

    for (var j = 0; j < nodes.length; j++) {
      if (nodes[j].classList.contains('is-in')) continue;
      revealObserver.observe(nodes[j]);
    }

    // Red de seguridad: si el observador no dispara (pestaña en segundo plano,
    // prerender, iframes del editor), nada puede quedarse invisible. A los
    // 1,5 s se revela lo que siga pendiente y el scroll ya no lo esconde.
    window.setTimeout(function () {
      var pending = (scope || document).querySelectorAll('[data-tv-reveal]:not(.is-in)');
      if (!pending.length) return;
      revealAll(pending);
      if (!revealObserver) return;
      for (var p = 0; p < pending.length; p++) revealObserver.unobserve(pending[p]);
    }, 1500);
  }

  /* 2) Elemento compartido entre lista y ficha ------------------------------ */
  function tagProductPageImage() {
    var info = document.querySelector('product-info[data-product-id]');
    if (!info) return;
    var img =
      document.querySelector('.product__media-item.is-active .product__media img') ||
      document.querySelector('.product__media-item .product__media img');
    if (!img || img.hasAttribute('data-tv-vt-id')) return;
    img.setAttribute('data-tv-vt-id', info.getAttribute('data-product-id'));
  }

  function clearSharedNames() {
    var named = document.querySelectorAll('[data-tv-vt-named]');
    for (var i = 0; i < named.length; i++) {
      named[i].style.viewTransitionName = '';
      if ('viewTransitionClass' in named[i].style) named[i].style.viewTransitionClass = '';
      named[i].removeAttribute('data-tv-vt-named');
    }
  }

  function initSharedNames(scope) {
    if (!('startViewTransition' in document)) return;
    // Con movimiento reducido no hay elementos compartidos (el CSS ya no
    // hace opt-in a la navegación con transición).
    if (reduced.matches) return;
    tagProductPageImage();
    var nodes = (scope || document).querySelectorAll('[data-tv-vt-id]');
    var seen = {};
    // Un nombre solo puede existir una vez por página: si el producto se repite
    // (carruseles), solo la primera imagen lo lleva.
    var existing = document.querySelectorAll('[data-tv-vt-named]');
    for (var k = 0; k < existing.length; k++) {
      seen[existing[k].getAttribute('data-tv-vt-id')] = true;
    }
    for (var i = 0; i < nodes.length; i++) {
      var id = nodes[i].getAttribute('data-tv-vt-id');
      if (!id || seen[id]) continue;
      seen[id] = true;
      nodes[i].style.viewTransitionName = 'tv-product-' + id;
      if ('viewTransitionClass' in nodes[i].style) nodes[i].style.viewTransitionClass = 'tv-product';
      nodes[i].setAttribute('data-tv-vt-named', '');
    }
  }

  /* 3) Burbuja del carrito -------------------------------------------------- */
  function popBubble(container) {
    var bubble = container.querySelector('.cart-count-bubble');
    if (!bubble) return;
    bubble.classList.remove('tv-pop');
    // Reinicia la animación aunque el nodo sea el mismo.
    void bubble.offsetWidth;
    bubble.classList.add('tv-pop');
    setTimeout(function () {
      bubble.classList.remove('tv-pop');
    }, 400);
  }

  function initCartBubble() {
    var container = document.getElementById('cart-icon-bubble');
    if (!container || !window.MutationObserver) return;
    if (container.hasAttribute('data-tv-pop-bound')) return;
    container.setAttribute('data-tv-pop-bound', '');

    var last = (container.textContent || '').trim();
    new MutationObserver(function () {
      var now = (container.textContent || '').trim();
      if (now === last) return;
      last = now;
      if (reduced.matches) return;
      popBubble(container);
    }).observe(container, { childList: true, subtree: true, characterData: true });
  }

  /* Cambio de preferencia durante la visita ---------------------------------- */
  function onMotionChange() {
    if (reduced.matches) {
      var pending = document.querySelectorAll('[data-tv-reveal]:not(.is-in)');
      revealAll(pending);
      if (revealObserver) {
        revealObserver.disconnect();
        revealObserver = null;
      }
      clearSharedNames();
    } else {
      initSharedNames(document);
    }
  }

  if (typeof reduced.addEventListener === 'function') reduced.addEventListener('change', onMotionChange);
  else if (typeof reduced.addListener === 'function') reduced.addListener(onMotionChange);

  /* ------------------------------------------------------------------------ */
  function init() {
    root.classList.add('tv-motion');
    initReveal(document);
    initSharedNames(document);
    initCartBubble();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // El editor de temas recarga secciones enteras.
  document.addEventListener('shopify:section:load', function (event) {
    initReveal(event.target);
    initSharedNames(event.target);
    initCartBubble();
  });
})();
